"use client";

import React from "react";

import { dictionaries } from "@/dictionaries/content";

import { type ISearchMarkerPayload } from "../../map-panel-context";

import { SectionBasicInfoList } from "./section-basic-info-list";

interface SearchMarkerPanelContentProps {
  payload: ISearchMarkerPayload | null;
}

export const SearchMarkerPanelContent: React.FC<SearchMarkerPanelContentProps> = ({
  payload,
}) => {
  const dict = dictionaries.mapPage.searchMarker;

  return (
    <div className="px-3 py-4">
      <SectionBasicInfoList
        items={[
          {
            type: "text",
            head: dict.addressLabel,
            value: payload?.address ?? "--",
          },
        ]}
      />
    </div>
  );
};
